import axios from '@/axios'

export default {
  getPaymentGateway (options) {
    return axios.get('/metode-pembayaran', options)
  }
}